<template>
  <div class="schoolCardList-container div-layout">
    <module-title title="学校管理设置列表" />
    <div class="schoolCardList-right-contain">
      <el-form
        ref="schoolCardSearchForm"
        class="schoolCardSearchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
      >
        <!-- <el-form-item label="选择省/市/区县：" prop="areaCode">
             <el-cascader
              v-model="searchForm.areaCode"
              :options="areaData"
              :props="areaProps"
              clearable
               @change="handleChangeArea"
               placeholder="选择省/市/区县"
              >
              </el-cascader>
        </el-form-item> -->
        <el-form-item label="学校名称：" prop="schoolName">
          <el-input
            v-model="searchForm.schoolName"
            name="schoolName"
            auto-complete="off"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item style="margin-left:20px;">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="fetchSearchFile"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="listLoading"
        :data="schoolManageList"
        fit
        element-loading-text="Loading"
        class="list-table"
        highlight-current-row
      >
        <el-table-column label="序号" type="index" align="center" width="55" />
        <el-table-column label="学校名称" prop="name" align="center" width="250" />
        <el-table-column label="所在区域" prop="areaName" align="center" />
        <el-table-column label="创建时间" prop="createDate" align="center" />
        <el-table-column label="纠偏距离" prop="range" align="center" />
        <el-table-column label="纠偏时间" prop="interval" align="center" />
        <el-table-column label="是否有人脸设备" prop="isBuySchFaceDevice" align="center">
          <template slot-scope="scope">
            {{ scope.row.isBuySchFaceDevice?'是':'否' }}
          </template>
        </el-table-column>
        <el-table-column label="是否有一卡通服务" prop="isHaveFaceService" align="center">
          <template slot-scope="scope">
            {{ scope.row.isHaveFaceService?'是':'否' }}
          </template>
        </el-table-column>
        <el-table-column label="是否有体测设备" prop="isBuySchSportDevice" align="center">
          <template slot-scope="scope">
            {{ scope.row.isBuySchSportDevice?'是':'否' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="280">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-setting"
              @click="handleResources(scope.row)"
            >
              点读笔资源配置
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 操作记录 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleResources"
      width="650px"
      title="点读笔资源配置"
    >
      <el-form
        ref="handleFormResources"
        :rules="handleResourcesRules"
        :model="handleFormResources"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="选择资源：" prop="resources">
          <el-select
            v-model="handleFormResources.resources"
            class="recommend-select"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :loading="resourcesloading"
          >
            <el-option
              v-for="item in resourceslist"
              :key="item.dirId"
              :label="item.dirName"
              :value="item.pathId+'|'+item.dirId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogVisibleResources = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddResource"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 学校管理设置 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="650px"
      title="学校管理设置"
    >
      <el-form
        ref="handleForm"
        :model="handleForm"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="纠偏距离：" prop="range">
          <el-select
            v-model="handleForm.range"
            placeholder="选择纠偏距离"
            name="range"
            size="medium"
            class="edit-form-input inlineblock"
          >
            <el-option
              v-for="item in rangeList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            />
          </el-select>
          <el-input
            v-if="handleForm.range===''"
            v-model="handleForm.rangeC"
            name="range"
            auto-complete="off"
            size="medium"
            placeholder="请输入纠偏距离"
            class="inlineblock"
            oninput="value=value.replace(/[^\d]/g,'')"
            clearable
          />
        </el-form-item>
        <el-form-item label="纠偏时间：" prop="interval">
          <el-select
            v-model="handleForm.interval"
            placeholder="选择纠偏时间"
            name="interval"
            size="medium"
            class="edit-form-input inlineblock"
          >
            <el-option
              v-for="item in intervalList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            />
          </el-select>
          <el-input
            v-if="handleForm.interval===''"
            v-model="handleForm.intervalC"
            name="interval"
            auto-complete="off"
            size="medium"
            placeholder="请输入纠偏时间"
            class="inlineblock"
            oninput="value=value.replace(/[^\d]/g,'')"
            clearable
          />
        </el-form-item>
        <el-form-item label="是否有人脸设备：" prop="isBuySchFaceDevice">
          <el-select
            v-model="handleForm.isBuySchFaceDevice"
            placeholder="选择是否有人脸设备"
            name="isBuySchFaceDevice"
            size="medium"
            class="edit-form-input"
          >
            <el-option :value="0" label="否" />
            <el-option :value="1" label="是" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否有一卡通服务：" prop="isHaveFaceService">
          <el-select
            v-model="handleForm.isHaveFaceService"
            placeholder="选择是否有一卡通服务"
            name="isHaveFaceService"
            size="medium"
            class="edit-form-input"
          >
            <el-option :value="0" label="否" />
            <el-option :value="1" label="是" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否有体测设备：" prop="isBuySchSportDevice">
          <el-select
            v-model="handleForm.isBuySchSportDevice"
            placeholder="选择是否有体测设备"
            name="isBuySchSportDevice"
            size="medium"
            class="edit-form-input"
          >
            <el-option :value="0" label="否" />
            <el-option :value="1" label="是" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddUpgrade"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  getSchoolSetList,
  getSchoolSetEdit,
  getOpenShowResource,
  getAddPenRsource,
  getResource
} from '@/api/systemMaintenance/devicManage/illegalCheck';
import { mapGetters } from 'vuex';
export default {
  name: 'CheckList',
  data() {
    return {
      schoolManageList: [],
      // areaProps: {
      //   value: 'code',
      //   label: 'name',
      //   children: 'children'
      // },
      searchForm: {
        schoolName: '',
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      resourcesloading: false,
      resourceslist: [],
      resourceslistCopy: [],
      handleForm: {},
      handleFormResources: {
        resources: [],
        schoolCode: ''
      },
      listLoading: false,
      ajaxLoading: false,
      dialogVisible: false,
      dialogVisibleResources: false,
      handleResourcesRules: {
        // resources: [
        //   { required: true, message: '资源不能为空', trigger: 'change' }
        // ]
      }

    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // ...mapGetters(['areaData']),
    rangeList() {
      return [{ value: '50米', code: '50' }, { value: '100米', code: '100' }, { value: '200米', code: '200' }, { value: '300米', code: '300' }, { value: '400米', code: '400' }, { value: '500米', code: '500' }, { value: '自定义', code: '' }];
    },
    intervalList() {
      return [{ value: '1分钟', code: '1' }, { value: '3分钟', code: '3' }, { value: '5分钟', code: '5' }, { value: '10分钟', code: '10' }, { value: '自定义', code: '' }];
    }
  },
  mounted() {
    // this.$store.dispatch('getNodes');
    this.fetchSchoolManageList();
    this.fetchResource();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchSchoolManageList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageSize = obj.limit;
      this.fetchSearchFile();
    },
    fetchSearchFile() {
      this.searchForm.pageNum = 1;
      this.fetchSchoolManageList();
    },
    // 获取资源列表
    fetchResource() {
      getResource().then(res => {
        if (res.data && res.data.length > 0) {
          this.resourceslistCopy = res.data;
          this.resourceslist = res.data;
        } else {
          this.resourceslist = [];
          this.resourceslistCopy = [];
        }
      });
    },
    // 获取资源列表
    fetchOpenShowResource() {
      const optionsArrShow = [];
      getOpenShowResource({ schoolCode: this.handleFormResources.schoolCode }).then(res => {
        const list = res.data;
        if (list && list.length > 0) {
          list.forEach(element => {
            optionsArrShow.push(element.pathId + '|' + element.dirId);
          });
        }
        this.handleFormResources.resources = optionsArrShow;
        this.dialogVisibleResources = true;
      });
    },
    // 获取列表名单
    fetchSchoolManageList() {
      var option = {
        ...this.searchForm
      };
      delete option.total;
      getSchoolSetList(option).then(res => {
        console.log(res);
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.schoolManageList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.schoolManageList = [];
        }
      });
    },
    // 编辑
    handleEdit(row) {
      this.dialogVisible = true;
      this.handleForm = {
        id: row.id,
        schoolCode: row.schoolCode,
        range: row.range,
        interval: row.interval,
        isHaveFaceService: row.isHaveFaceService,
        isBuySchFaceDevice: row.isBuySchFaceDevice,
        isBuySchSportDevice: row.isBuySchSportDevice
      };
    },
    handleResources(row) {
      this.handleFormResources = {
        resources: [],
        schoolCode: row.schoolCode
      };
      this.fetchOpenShowResource();
    },

    handleAddResource() {
      this.$refs['handleFormResources'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          const optionsArr = [];
          this.handleFormResources.resources.forEach(element => {
            const result = {};
            result.pathId = element.split('|')[0];
            result.dirId = element.split('|')[1];
            result.schoolCode = this.handleFormResources.schoolCode;
            result.createUserCode = this.userInfo.code ? this.userInfo.code : '';
            optionsArr.push(result);
          });
          getAddPenRsource({
            schoolCode: this.handleFormResources.schoolCode,
            dto: optionsArr
          })
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '操作成功',
                showClose: false,
                duration: 2000
              });
              this.ajaxLoading = false;
              this.dialogVisibleResources = false;
              this.fetchSchoolManageList();
            })
            .catch(err => {
              this.ajaxLoading = false;
              console.log(err);
            });
        }
      });
    },

    handleAddUpgrade() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          var options = {
            id: this.handleForm.id,
            schoolCode: this.handleForm.schoolCode,
            range: this.handleForm.range ? this.handleForm.range : this.handleForm.rangeC,
            interval: this.handleForm.interval ? this.handleForm.interval : this.handleForm.intervalC,
            isHaveFaceService: this.handleForm.isHaveFaceService,
            isBuySchFaceDevice: this.handleForm.isBuySchFaceDevice,
            isBuySchSportDevice: this.handleForm.isBuySchSportDevice
          };
          getSchoolSetEdit(options)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '操作成功',
                showClose: false,
                duration: 2000
              });
              this.ajaxLoading = false;
              this.dialogVisible = false;
              this.fetchSchoolManageList();
            })
            .catch(err => {
              this.ajaxLoading = false;
              console.log(err);
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.schoolCardList-container {
  .schoolCardSearchForm{
    padding: 0 20px;
  }
  .inlineblock{
    position: relative;
    display: inline-block;
    width: 180px;
    margin-right: 10px;

  }
    .edit-form-input {
      width: 50%;
    }
    .textCenter{text-align: center;padding: 20px;
    .el-button {
      width: 160px;
    }

  }

  // .handle-form-input{ width: 160px;}
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .red{color: red;}
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
